var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstPrize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.136,
    height: 68.92,
    viewBox: "0 0 47.136 68.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122539",
    "data-name": "Group 122539",
    transform: "translate(813 -21719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122538",
    "data-name": "Group 122538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122537",
    "data-name": "Group 122537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M22.459,45.416h-.011A22.495,22.495,0,0,1,0,22.8a21.909,21.909,0,0,1,1.786-8.587A22.841,22.841,0,0,1,13.644,2.318,22.168,22.168,0,0,1,22.256.478l.266,0A22.129,22.129,0,0,1,38.3,6.988,22.37,22.37,0,0,1,44.83,22.844a22.462,22.462,0,0,1-6.518,16.063A22.2,22.2,0,0,1,22.46,45.415h0ZM25.14,11.25,16.7,12.781v2.61h3.891V30.8l-3.844.469V34H28.984V31.266L25.14,30.8Z",
    transform: "translate(-811.733 21742)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171696",
    "data-name": "Path 171696",
    d: "M47.136.041C42.07.041,37.805-.1,33.563.154c-.93.057-2.195,1.385-2.586,2.4-1.831,4.771-3.41,9.639-5.1,14.524l13.679,4.843L47.136.041",
    transform: "translate(-813 21719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171697",
    "data-name": "Path 171697",
    d: "M18.123,18.32c.976-.361,2.6-1.516,2.494-1.874-1.6-5.317-3.42-10.571-5.3-15.8C15.186.284,14.154.09,13.539.083,9.285.036,5.03.058,0,.058L7.793,21.765c3.8-1.25,7.1-2.251,10.33-3.445",
    transform: "translate(-813 21719)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPrize);
export default __webpack_public_path__ + "static/media/firstPrize.c45c9498948011037d227322a146092e.svg";
export { ForwardRef as ReactComponent };